import { api } from '@/config/api';

export interface InsightsTrendPoint {
  date: string;            // YYYY-MM-DD
  impressions: number;
  clicks: number;
  spend: number;
  reach: number;
  conversions: number;
}

const BASE = '/slighter_crm/facebook/insights';

export const facebookInsightsService = {
  campaignTrend: async (campaignId: string, since: string, until: string): Promise<InsightsTrendPoint[]> =>
    (await api.get(`${BASE}/campaign-trend`, { params: { campaignId, since, until } })).data,

  campaignTrendsBulk: async (
    campaignIds: string[],
    since: string,
    until: string,
  ): Promise<Record<string, InsightsTrendPoint[]>> => {
    if (campaignIds.length === 0) return {};
    return (await api.get(`${BASE}/campaign-trends-bulk`, {
      params: { campaignIds: campaignIds.join(','), since, until },
    })).data;
  },

  accountTrend: async (since: string, until: string): Promise<InsightsTrendPoint[]> =>
    (await api.get(`${BASE}/account-trend`, { params: { since, until } })).data,

  /** Backfill last N days. Admin-only. */
  backfill: async (days = 30): Promise<{ accounts: number; rows: number }> =>
    (await api.post(`${BASE}/backfill`, undefined, { params: { days } })).data,
};
